export interface ScannerResult {
  rawValue: string;
  format: string;
}

export interface ScannerAdapter {
  readonly id: string;
  isSupported(): Promise<boolean>;
  scan(source: ImageBitmapSource): Promise<ScannerResult[]>;
}

export interface BarcodeDetectorShape {
  detect(source: ImageBitmapSource): Promise<Array<{ rawValue?: string; format?: string }>>;
}

export interface BarcodeDetectorConstructorShape {
  getSupportedFormats?: () => Promise<string[]>;
  new (options?: { formats?: string[] }): BarcodeDetectorShape;
}

export function readBarcodeDetectorConstructor(): BarcodeDetectorConstructorShape | undefined {
  const candidate = (globalThis as { BarcodeDetector?: unknown }).BarcodeDetector;

  if (typeof candidate !== 'function') {
    return undefined;
  }

  return candidate as BarcodeDetectorConstructorShape;
}
